import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-whats-delete-modal',
  templateUrl: './whats-delete-modal.component.html',
  styleUrls: ['./whats-delete-modal.component.scss']
})
export class WhatsDeleteModalComponent {
  @Input() releaseNotesID: number;

  constructor(public activeModal: NgbActiveModal) {}

  confirmDelete(): void {
    this.activeModal.close(true);
  }
}